import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userPrefLangList: [],
  uiTheme: {
    bannerColour: "#ffffff",
    bgColour: "#ffffff",
    buttonColour: "#DD6B20",
    buttonFontColour: "#ffffff"
  },
  productUrls: {
    logo: "",
    bgImg: "",
    termsAndConditions: "",
    privacyStatement: "",
    cookieInformation: "",
    loginPage: "",
  },
  activationFailureErrorMsg: "",
  profileStatus: "",
}

export const activationSlice = createSlice({
  name: 'activation',
  initialState,
  reducers: {
    setUserPrefLangList: (state, action) =>
    {
      state.userPrefLangList = action.payload
    },
    setUITheme: (state, action) =>
    {
      state.uiTheme = action.payload
    },
    setProductUrls: (state, action) =>
    {
      state.productUrls = action.payload
    },
    setActivationFailureErrorMsg: (state, action) =>
    {
      state.activationFailureErrorMsg = action.payload
    },
    setProfileStatus: (state, action) => 
    {
      state.profileStatus = action.payload
    }
  }
});

export const { setUITheme, setUserPrefLangList, setProductUrls, setActivationFailureErrorMsg, setProfileStatus } = activationSlice.actions;

export default activationSlice.reducer;